import styled from 'styled-components';
import { PleaseWaitLoader } from '../PleaseWaitLoader/styles';

export const NoBorder = styled.div`
  ${PleaseWaitLoader} {
    border: none;
  }
`;
